import type { CapabilityErrorUnion } from '../capabilityError';
import { makeCapabilityErrors } from '../capabilityError';

/**
 * What `CategoryListing` reports when a read does not answer.
 *
 * `NotFound` is a 404, `ContractMismatch` a body the curated schema rejects,
 * and `Unavailable` everything else — any other status, and the network. A
 * loader matches on these three and never on the tenant error the adapter
 * mapped from.
 */
export const CategoryListingError = makeCapabilityErrors('CategoryListing');

export type CategoryListingError = CapabilityErrorUnion<typeof CategoryListingError>;
